/* tslint:disable */
/* eslint-disable */
/**
 * BlackFriday API
 * The API Documentation for BlackFriday
 *
 * The version of the OpenAPI document: 0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from "../runtime";
import type { PlatformSyncStatusDTOLastRun } from "./PlatformSyncStatusDTOLastRun";
import {
  PlatformSyncStatusDTOLastRunFromJSON,
  PlatformSyncStatusDTOLastRunFromJSONTyped,
  PlatformSyncStatusDTOLastRunToJSON
} from "./PlatformSyncStatusDTOLastRun";

/**
 *
 * @export
 * @interface PlatformSyncStatusDTO
 */
export interface PlatformSyncStatusDTO {
  /**
   *
   * @type {number}
   * @memberof PlatformSyncStatusDTO
   */
  platformId: number;
  /**
   *
   * @type {string}
   * @memberof PlatformSyncStatusDTO
   */
  name: string;
  /**
   *
   * @type {boolean}
   * @memberof PlatformSyncStatusDTO
   */
  productPageSyncEnabled: boolean;
  /**
   * Online pages for this platform (all pages, not just sync-managed).
   * @type {number}
   * @memberof PlatformSyncStatusDTO
   */
  pageLiveCount: number;
  /**
   * Offline pages for this platform (all pages, not just sync-managed).
   * @type {number}
   * @memberof PlatformSyncStatusDTO
   */
  pageOfflineCount: number;
  /**
   * Automatic (createdBy = API) pages for this platform, live + offline.
   * @type {number}
   * @memberof PlatformSyncStatusDTO
   */
  pageAutomaticCount: number;
  /**
   *
   * @type {PlatformSyncStatusDTOLastRun}
   * @memberof PlatformSyncStatusDTO
   */
  lastRun?: PlatformSyncStatusDTOLastRun | null;
  /**
   * True when the newest run for this platform has status RUNNING.
   * @type {boolean}
   * @memberof PlatformSyncStatusDTO
   */
  isRunning: boolean;
}

/**
 * Check if a given object implements the PlatformSyncStatusDTO interface.
 */
export function instanceOfPlatformSyncStatusDTO(value: object): boolean {
  let isInstance = true;
  isInstance = isInstance && "platformId" in value;
  isInstance = isInstance && "name" in value;
  isInstance = isInstance && "productPageSyncEnabled" in value;
  isInstance = isInstance && "pageLiveCount" in value;
  isInstance = isInstance && "pageOfflineCount" in value;
  isInstance = isInstance && "pageAutomaticCount" in value;
  isInstance = isInstance && "isRunning" in value;

  return isInstance;
}

export function PlatformSyncStatusDTOFromJSON(json: any): PlatformSyncStatusDTO {
  return PlatformSyncStatusDTOFromJSONTyped(json, false);
}

export function PlatformSyncStatusDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): PlatformSyncStatusDTO {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    platformId: json["platformId"],
    name: json["name"],
    productPageSyncEnabled: json["productPageSyncEnabled"],
    pageLiveCount: json["pageLiveCount"],
    pageOfflineCount: json["pageOfflineCount"],
    pageAutomaticCount: json["pageAutomaticCount"],
    lastRun: !exists(json, "lastRun") ? undefined : PlatformSyncStatusDTOLastRunFromJSON(json["lastRun"]),
    isRunning: json["isRunning"]
  };
}

export function PlatformSyncStatusDTOToJSON(value?: PlatformSyncStatusDTO | null): any {
  if (value === undefined) {
    return undefined;
  }
  if (value === null) {
    return null;
  }
  return {
    platformId: value.platformId,
    name: value.name,
    productPageSyncEnabled: value.productPageSyncEnabled,
    pageLiveCount: value.pageLiveCount,
    pageOfflineCount: value.pageOfflineCount,
    pageAutomaticCount: value.pageAutomaticCount,
    lastRun: PlatformSyncStatusDTOLastRunToJSON(value.lastRun),
    isRunning: value.isRunning
  };
}
